export default "__VITE_ASSET__o$MyB4Ed__"